export const MenuAlignRightIcon = (props) => (
  <svg
    width={props?.width || '18'}
    height={props?.height || '18'}
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 6H13.1667M1.5 1H16.5M1.5 11H16.5"
      stroke={props?.color || '#2E51CD'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
